/* eslint-disable react-hooks/exhaustive-deps */
import { createStyles, FormControl, FormControlLabel, IconButton, makeStyles, Radio, RadioGroup, Theme } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { ChartCommonProps, IconButtonWrapper } from '../Common';
import { ChartFilter } from '../ChartComponents';
import { SearchCriteria } from '../SearchCriteria';
import { convertStringNumberToNumber, formatNumber, getLabels, getMaxTickLimit, getSuggestedMaxTick } from '../../helpers/ChartHelper';
// import { DrillDownType } from '../DrillDownType';
import CloseIcon from '@material-ui/icons/Close';
import { SelectedItemProps } from '../MattersByStatusChart';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';
import { RvLoader } from '../../components/Loader';
import { Bar, getElementAtEvent } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, Scale, Tick } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import { ChartInfo } from '../../components/ChartInfo';
import { DrillDownType } from '../DrillDownType';

import { RV_CHART_CLASS, RV_CHART_COLORS, isChartDataEmpty, rvBarDatasetStyle, rvChartAnimation, rvCategoryAxisStyle, rvTooltipStyle, rvValueAxisStyle } from '../chartTheme';
import { ChartHeading } from '../ChartHeading';
import { ChartSkeleton } from '../../components/loading/ChartSkeleton';
import { AnimatedNumber } from '../AnimatedNumber';
import { ChartEmptyState } from '../ChartEmptyState';
import ContactMailOutlinedIcon from '@material-ui/icons/ContactMailOutlined';
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, zoomPlugin);

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        rootLoader: {
            display: 'flex',
            flexFlow: 'column',
            maxWidth: '100%',
            maxHeight: '100%',
            height: '100%',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
        },
        root: {
            position: 'relative',
            paddingBottom: '10px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            maxWidth: '100%',
            maxHeight: '100%',
            height: '100%',
            textAlign: 'center',
            '@media print': {
                display: 'flex',
                flexFlow: 'column',
                alignItems: 'center',
                boxShadow: 'none !important',
            },
        },
        popover: {},
        paper: {},
        radioGroup: {
            flexFlow: 'row wrap',
            justifyContent: 'center',
        },
        closeIcon: {
            color: 'rgb(0, 120, 212)',
        },
        titleContainer: {
            display: 'flex',
            flexFlow: 'column',
            padding: '20px 15px 0px 15px',
        },
        barContainer: {
            padding: '5px 15px 15px 15px',
            minHeight: '300px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            maxHeight: '350px',
            maxWidth: 'auto',
            position: 'relative',
            '@media (max-width: 533px)': {
                maxWidth: '350px',
                margin: '0 auto',
            },
            '& .titleWrapper': {
                textAlign: 'center',
                display: 'inline-block',
                width: '100%',
                padding: '15px',
                '& .title': {
                    fontSize: '18px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .value': {
                    fontSize: '24px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .secondary-title': {
                    fontSize: '16px',
                    fontWeight: 400,
                    display: 'block',
                    marginBottom: '15px',
                },
            },
        },
        loadingWrapper: {
            padding: '20px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
        },
        title: {
            fontSize: 16,
            fontWeight: 600,
            fontFamily: 'inherit',
            marginBottom: 0,
        },
        totalDiv: {
            cursor: 'pointer',
            paddingRight: 5,
        },
        total: {
            fontSize: '2.5rem',
            padding: '10px 0',
            fontWeight: 600,
            cursor: 'pointer',
        },
        span: {
            fontSize: '1rem',
        },
        helpIcon: {
            position: 'absolute',
            left: '5px',
            top: '5px',
            '@media print': {
                display: 'none !important',
            },
        },
        formControl: {
            display: 'flex',
            flexFlow: 'row wrap',
            alignItems: 'center',
            justifyContent: 'center',
        },
        formLabel: {
            marginRight: '10px',
        },
        scrollUp: {
            position: 'absolute',
            top: '30px',
            justifyContent: 'center',
            transform: 'translateX(-50%)',
            left: '50%',
            minWidth: '54px',
        },
        scrollDown: {
            position: 'absolute',
            bottom: '90px',
            justifyContent: 'center',
            transform: 'translateX(-50%)',
            left: '50%',
            minWidth: '54px',
        }
    }),
);

export enum ChartOptionEnum {
    Last30Days = 0,
    Last90Days,
    Last12Months,
    AllTime
}

interface ContactActivitiesByStaffChartProps extends SelectedItemProps, ChartCommonProps {
    chartFilter?: ChartFilter;
    selectedOption?: number;
}

interface ChartState {
    option: ChartOptionEnum
    total : number | null | undefined,
    count: number[],
    grouping: string[],
    format: string[],
    periodString: string
}

export const ContactActivitiesByStaffChart: React.FC<ContactActivitiesByStaffChartProps> = (props) => {
    const classes = useStyles();

    // tslint:disable-next-line:no-any
    const chartRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const entireChartRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const contactActivitiesByStaffChartQuery = useQuery<ContactActivitiesByStaffChartData>(ContactActivitiesByStaffChartQuery, {
        variables: {
            entityType: props.chartFilter?.entityType,
            entityGuid: props.chartFilter?.entityGuid,
            responsibility: props.chartFilter?.responsibility,
        },
        fetchPolicy: 'network-only',
    });

    
    const [state, setState] = useState<ChartState>({
        option: props.selectedOption === undefined ? ChartOptionEnum.Last12Months : props.selectedOption,
        total: 0,
        count: [],
        grouping: [],
        format: [],
        periodString: ''
    });

    const getPeriodString = (option: ChartOptionEnum) => {
        switch (option) {
            case ChartOptionEnum.Last30Days:
                return 'Last 30 Days';
            case ChartOptionEnum.Last90Days:
                return 'Last 90 Days';
            case ChartOptionEnum.Last12Months:
                return 'Last 12 Months';
            default: 
                return 'All Time';
        }
    }

    useEffect(() => {
        let total: number | null | undefined = null;
        let count: number[] = [];
        let grouping: string[] = [];
        let format: string[] = [];
        let periodString: string = '';

        if (
            contactActivitiesByStaffChartQuery.data &&
            contactActivitiesByStaffChartQuery.data.statistics &&
            contactActivitiesByStaffChartQuery.data.statistics.matter &&
            !contactActivitiesByStaffChartQuery.loading &&
            !contactActivitiesByStaffChartQuery.error
        ) {
            setState((prevState) => {
                let last30Days = contactActivitiesByStaffChartQuery.data?.statistics.matter.contactActivitiesByStaff.last30Days;
                let last90Days = contactActivitiesByStaffChartQuery.data?.statistics.matter.contactActivitiesByStaff.last90Days;
                let last12months = contactActivitiesByStaffChartQuery.data?.statistics.matter.contactActivitiesByStaff.last12Months;
                let allTime = contactActivitiesByStaffChartQuery.data?.statistics.matter.contactActivitiesByStaff.allTime;
                let summary = contactActivitiesByStaffChartQuery.data?.statistics.matter.contactActivitiesByStaff.summary;

                if (state.option === ChartOptionEnum.Last30Days) {
                    count = last30Days?.map((data: ContactActivity) => data.count) ?? [];
                    grouping = last30Days?.map((data: ContactActivity) => data.grouping) ?? [];
                    format = last30Days?.map((data: ContactActivity) => data.format) ?? [];
                    total = summary?.last30Days;   
                    
                    periodString = getPeriodString(state.option);

                } else if (state.option === ChartOptionEnum.Last90Days) {
                    count = last90Days?.map((data: ContactActivity) => data.count) ?? [];
                    grouping = last90Days?.map((data: ContactActivity) => data.grouping) ?? [];
                    format = last90Days?.map((data: ContactActivity) => data.format) ?? [];
                    total = summary?.last90Days;   

                    periodString = 'Last 90 Days';
                } else  if (state.option === ChartOptionEnum.Last12Months) {
                    count = last12months?.map((data: ContactActivity) => data.count) ?? [];
                    grouping = last12months?.map((data: ContactActivity) => data.grouping) ?? [];
                    format = last12months?.map((data: ContactActivity) => data.format) ?? [];
                    total = summary?.last12Months;

                    periodString = getPeriodString(state.option);
                } else {
                    count = allTime?.map((data: ContactActivity) => data.count) ?? [];
                    grouping = allTime?.map((data: ContactActivity) => data.grouping) ?? [];
                    format = allTime?.map((data: ContactActivity) => data.format) ?? [];
                    total = summary?.allTime;

                    periodString = getPeriodString(state.option);
                }

                return {
                    ...prevState,
                    total,
                    count,
                    grouping,
                    format,
                    periodString
                };
            });
        }

        // tslint:disable-next-line: align
    }, [state.option, contactActivitiesByStaffChartQuery.loading, contactActivitiesByStaffChartQuery.error, contactActivitiesByStaffChartQuery.data]);

    const onCloseChart = () => {
        if (props.onCloseChart) {
            props.onCloseChart('isContactActivitiesByStaffChartOpen');
        }
    };

    const chartControllerComponent = () => {
        return (
            <>
                <IconButtonWrapper aria-label="close">
                    <ChartInfo 
                        description={props.description}
                        fontSize={props.showAllRecords ? 'large' : 'medium'}
                        className={`${classes.helpIcon} rv-chart-help`}
                    />
                    <IconButton aria-label="close" onClick={onCloseChart} size="small">
                        <CloseIcon className={classes.closeIcon} />
                    </IconButton>
                </IconButtonWrapper>
            </>
        );
    };
    
    if (contactActivitiesByStaffChartQuery.loading || contactActivitiesByStaffChartQuery.loading) {
        return (
            <div className={classes.rootLoader}>
                {chartControllerComponent()}
                <RvLoader size="small" />
            </div>
        );
    }

    const onChangeRadio = (event: React.ChangeEvent<HTMLInputElement>) => {
        setState((prevState) => {
            return {
                ...prevState,
                // tslint:disable-next-line: radix
                option: parseInt(event.target.value),
            };
        });
    };

    const getLastPeriodComparison = (option: ChartOptionEnum) => {
        switch (option) {
            case ChartOptionEnum.Last30Days:
                return 30 + '';
            case ChartOptionEnum.Last90Days:
                return 90 + '';
            case ChartOptionEnum.Last12Months:
                return 12 + '';
            default: 
                return Number.MAX_SAFE_INTEGER + '';
        }
    }

    const handleTotalClick = () => {
        if (props.getSelectedItem) {
            const searchCriterias = new Array<SearchCriteria>();

            searchCriterias.push({
                property: 'IncludeIndividual',
                operator: 'eq',
                comparison: 'true'
            });

            searchCriterias.push({
                property: 'IncludeOrganisation',
                operator: 'eq',
                comparison: 'true'
            });

            searchCriterias.push({
                property: 'LastPeriod',
                operator: 'staff',
                comparison: getLastPeriodComparison(state.option)
            });

            if (props.chartFilter && props.chartFilter.entityType === 8) {
                searchCriterias.push({
                    property: 'NameId',
                    operator: 'eq',
                    comparison: props.chartFilter.entityGuid ?? ''
                });
            }

            const title = `Drilldown from Contact Activities by Staff - ${getPeriodString(state.option)}`;

            props.getSelectedItem(
                searchCriterias, 
                true, 
                title, 
                DrillDownType.notesSummary, 
                'Phone Call',
                {
                    includeEventsAndCampaign: true,
                    isMyActivityOnly: false,
                    entityType: props.chartFilter?.entityType,
                    entityGuid: props.chartFilter?.entityGuid,
                    responsibility: props.chartFilter?.responsibility,
                }
            );
        }
    };
    
    if (contactActivitiesByStaffChartQuery.loading) {
        return (
            <ChartSkeleton variant="bars" />
        );
    }

    return (
        <div className={`${classes.root} ${RV_CHART_CLASS}${isChartDataEmpty(state.count) ? ' rv-chart--empty' : ''}`} ref={entireChartRef}>
            {chartControllerComponent()}
            <div className={classes.titleContainer}>
                <ChartHeading icon={<ContactMailOutlinedIcon />} title="Contact Activities by Staff" />
                <div className={`${classes.total} h2`} onClick={handleTotalClick}>
                    <AnimatedNumber value={state.total ?? 0} format={(amount) => `${formatNumber(amount)}`} />
                </div>
                <div className="h3">{state.periodString}</div>
            </div>
            <div className={classes.barContainer} style={{ maxHeight: props.showAllRecords ? '100%' : '350px' }}>
                <Bar
                    ref={chartRef}
                    // tslint:disable-next-line: no-any
                    onClick={(event: React.MouseEvent<any>) => {
                        const _data = getElementAtEvent(chartRef.current, event);
                        if (_data.length > 0 && props.getSelectedItem) {
                            const _index = getElementAtEvent(chartRef.current, event)[0].index;
                            const grouping = state.grouping[_index];
                            const format = state.format[_index];
                            const searchCriterias = new Array<SearchCriteria>();

                            searchCriterias.push({
                                property: 'IncludeIndividual',
                                operator: 'eq',
                                comparison: 'true'
                            });
                
                            searchCriterias.push({
                                property: 'IncludeOrganisation',
                                operator: 'eq',
                                comparison: 'true'
                            });
                
                            searchCriterias.push({
                                property: 'LastPeriod',
                                operator: 'staff',
                                comparison: getLastPeriodComparison(state.option)
                            });

                            searchCriterias.push({
                                property: 'StaffGuid',
                                operator: 'eq',
                                comparison: grouping
                            });

                            if (props.chartFilter && props.chartFilter.entityType === 8) {
                                searchCriterias.push({
                                    property: 'NameGuid',
                                    operator: 'eq',
                                    comparison: props.chartFilter.entityGuid ?? ''
                                });
                            }
                
                            const title = `Drilldown from Contact Activities by Staff - ${getPeriodString(state.option)} - ${format}`;
                
                            props.getSelectedItem(
                                searchCriterias, 
                                true, 
                                title, 
                                DrillDownType.notesSummary, 
                                'Phone Call',
                                {
                                    includeEventsAndCampaign: true,
                                    isMyActivityOnly: false,
                                    entityType: props.chartFilter?.entityType,
                                    entityGuid: props.chartFilter?.entityGuid,
                                    responsibility: props.chartFilter?.responsibility,
                                }
                            );
                        }
                    }}
                    data={{
                        labels: getLabels(state.format),
                        datasets: [
                            {
                                label: 'Contact Activities',
                                ...rvBarDatasetStyle(RV_CHART_COLORS.primary, true),
                                data: state.count,
                            },
                        ],
                    }}
                    options={{
                        indexAxis: 'y' as const,
                        animation: rvChartAnimation(),
                        elements: { bar: { borderWidth: 0 } },
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            x: {
                                grid: rvValueAxisStyle.grid,
                                stacked: true,
                                suggestedMax: getSuggestedMaxTick(state.count),
                                beginAtZero: true,
                                ticks: {
                                    ...rvValueAxisStyle.ticks,
                                    maxTicksLimit: getMaxTickLimit(state.count),
                                    autoSkip: false,
                                    callback: function (this: Scale, tickValue: number, index: number, ticks: Tick[]) {
                                        return `${tickValue}`;
                                    },
                                },
                            },
                            y: {
                                grid: rvCategoryAxisStyle.grid,
                                stacked: true,
                                max: 9,
                                ticks: {
                                    ...rvCategoryAxisStyle.ticks,
                                    autoSkip: false,
                                }
                            }
                        },
                        plugins: {
                            legend: {
                                position: 'bottom' as const,
                                display: false,
                            },
                            title: {
                                display: false,
                                text: ``,
                            },
                            zoom: {
                                pan: {
                                    enabled: false,
                                },
                                zoom: {
                                    wheel: {
                                        enabled: false,
                                    },
                                },
                            },
                            tooltip: {
                                ...rvTooltipStyle,
                                callbacks: {
                                    // tslint:disable-next-line: no-any
                                    label: function (context: any) {
                                        const {
                                            formattedValue,
                                            dataset,
                                        } = context;

                                        var currentValue = convertStringNumberToNumber(formattedValue);

                                        return [`${dataset.label}: ${formatNumber(currentValue)}`];
                                    },
                                },
                            },
                        },
                    }}
                />
                {isChartDataEmpty(state.count) && (
                    <ChartEmptyState title="No data" hint="Nothing to show for this selection." />
                )}
            </div>
            <FormControl component="div">
                <RadioGroup name="last" value={state.option} onChange={onChangeRadio} className={classes.radioGroup}>
                    <FormControlLabel value={ChartOptionEnum.Last30Days} control={<Radio color="primary" />} label="Last 30 Days" />
                    <FormControlLabel value={ChartOptionEnum.Last90Days} control={<Radio color="primary" />} label="Last 90 Days" />
                    <FormControlLabel value={ChartOptionEnum.Last12Months} control={<Radio color="primary" />} label="Last 12 Months" />
                    <FormControlLabel value={ChartOptionEnum.AllTime} control={<Radio color="primary" />} label="All Time" />
                </RadioGroup>
            </FormControl>
        </div>
    );
};

export interface ContactActivitiesByStaffChartData {
    statistics: Statistics;
}

export interface Statistics {
    matter: Matter;
}

export interface Matter {
    contactActivitiesByStaff : ContactActivitiesByStaff;
}

export interface ContactActivitiesByStaff {
    last30Days: ContactActivity[];
    last90Days: ContactActivity[];
    last12Months: ContactActivity[];
    allTime: ContactActivity[];
    summary: ContactActivitySummary;
}

export interface ContactActivity {
    grouping: string;
    format: string;
    count: number;
}

export interface ContactActivitySummary {
    last30Days: number;
    last90Days: number;
    last12Months: number;
    allTime: number;
}

const ContactActivitiesByStaffChartQuery = gql`
fragment contactActivitiesFragment on ContactActivity {
  format
  grouping
  count
}

query ContactActivitiesByStaff ($entityGuid: String, $entityType: Int, $responsibility: Int) {
  statistics {
    matter {
      contactActivitiesByStaff (entityGuid: $entityGuid, entityType: $entityType, responsibility: $responsibility) {
        last30Days {
          ... contactActivitiesFragment
        }
        last90Days {
          ... contactActivitiesFragment
        }
        last12Months {
          ... contactActivitiesFragment
        }
        allTime {
          ... contactActivitiesFragment
        }
        summary {
          last30Days
          last90Days
          last12Months
          allTime
        }
      }
    }
  }
}
`;
